<div *transloco="let t" class="admin-menu h-full">
  <div class="admin-menu__header">
    <div class="admin-menu__brand">
      <img src="police-logo.svg" width="64" height="64" alt="Police Logo" />
      <img src="rieaya-logo.svg" width="64" height="64" alt="Rieaya Logo" />
    </div>

    <div class="admin-menu__search">
      <i [class]="icons.search" class="admin-menu__search-icon"></i>
      <input
        pInputText
        type="search"
        class="admin-menu__search-input"
        [formControl]="searchControl"
        [placeholder]="t('shared/search')"
        autocomplete="off"
      />
    </div>
  </div>

  <nav id="links" class="admin-menu__links" aria-label="Main menu">
    @if (menuItems.length > 0) {
    @for (item of menuItems; track trackMenuItem($index, item)) {
    <ng-container
      *ngTemplateOutlet="
        menuItemTemplate;
        context: { item: item, currentDepth: 0 }
      "
    ></ng-container>
    }
    } @else {
    <div class="admin-menu__empty">
      <i [class]="icons.search"></i>
      <span>{{ t('shared/noMenuResults') }}</span>
    </div>
    }

    <ng-template
      #menuItemTemplate
      let-item="item"
      let-currentDepth="currentDepth"
    >
      @if (!item.children?.length) {
      <a
        [routerLink]="item.href"
        [queryParamsHandling]="null"
        class="admin-menu__item admin-menu__link"
        [class.admin-menu__item--active]="isActive(item.href || '')"
        [class.admin-menu__item--nested]="currentDepth > 0"
        [style.--menu-depth]="currentDepth"
        [title]="item.label"
      >
        <span class="admin-menu__icon">
          <i [ngClass]="item.icon"></i>
        </span>
        <span class="admin-menu__label">{{ item.label }}</span>
      </a>
      } @else {
      <div class="admin-menu__group">
        <button
          type="button"
          class="admin-menu__item admin-menu__trigger"
          [class.admin-menu__item--active]="hasActiveDescendant(item)"
          [class.admin-menu__item--open]="isExpanded(item)"
          [style.--menu-depth]="currentDepth"
          [title]="item.label"
          (click)="toggleItem(item)"
        >
          <span class="admin-menu__icon">
            <i [ngClass]="item.icon"></i>
          </span>
          <span class="admin-menu__label">{{ item.label }}</span>
          <span class="admin-menu__chevron">
            <i
              class="pi"
              [ngClass]="{
                'pi-chevron-down': isExpanded(item),
                'pi-chevron-right': !isExpanded(item)
              }"
            ></i>
          </span>
        </button>

        @if (isExpanded(item)) {
        <div class="admin-menu__children">
          @for (child of item.children; track trackMenuItem($index, child)) {
          <ng-container
            *ngTemplateOutlet="
              menuItemTemplate;
              context: { item: child, currentDepth: currentDepth + 1 }
            "
          ></ng-container>
          }
        </div>
        }
      </div>
      }
    </ng-template>
  </nav>

  <div id="footer" class="admin-menu__footer">v1.0</div>
</div>
